import React, { useState } from 'react';
import { CardBody, Container, Input, Row, Col, Card } from 'reactstrap';
import ErrorBoundary from 'components/ErrorBoundary';
import PaymentActivity from 'components/PaymentActivity';
import PharmacyDetails from 'components/PharmacyDetails';
import CapturedActivity from 'components/CapturedActivity';
import ReplenishedActivity from 'components/ReplenishedActivity';
import { onExport } from "utils/helper";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: 'modifiedDate',
    order: 'desc',
    filters: [],
};

let handleFilterReset = 0;

const PaymentReconciliation = (props) => {

    const {
        loading,
        apiFilter,
        apiFilterpharmacy,
        apiFiltercaptured,
        apiFilterreplenish,
        totalSize,
        handleSearchPaymentActivityColumnFilters,
        handlePaymentActivityPageChange,
        paymenttabledata,
        fetchPaymentActivityList,
        handleSearchPharmacyDetailsColumnFilters,
        handlePharmacyDetailsPageChange,
        pharmacytabledata,
        fetchPharmacyDetailsList,
        handleSearchCapturedActivityColumnFilters,
        handleCapturedPageChange,
        capturedtabledata,
        fetchCapturedActivityList,
        handleSearchReplenishedActivityColumnFilters,
        handleReplenishedPageChange,
        replenishedtabledata,
        fetchReplenishedActivityList,
        CoveredEntity,
        opaCode,
        Cycle,
        TotalPaymentReceived,
        PendingAmount,
        payloaddata,
        payActrefetch,
        phaActrefetch,
        CapActrefetch,
        RepActrefetch
    } = props;

    const [key, setkey] = useState('paymentactivityTab');
    const [reset, setReset] = useState(false);

    const onKeyChange = (k) => {

        apiFilter.pageSize = 10;
        apiFilter.currentPage = 1;
        apiFilter.order = "desc";
        apiFilter.orderBy = "modifiedDate";
        apiFilterpharmacy.pageSize = 10;
        apiFilterpharmacy.currentPage = 1;
        apiFilterpharmacy.order = "desc";
        apiFilterpharmacy.orderBy = "modifiedDate";
        apiFiltercaptured.pageSize = 10;
        apiFiltercaptured.currentPage = 1;
        apiFiltercaptured.order = "desc";
        apiFiltercaptured.orderBy = "modifiedDate";
        apiFilterreplenish.pageSize = 10;
        apiFilterreplenish.currentPage = 1;
        apiFilterreplenish.order = "desc";
        apiFilterreplenish.orderBy = "modifiedDate";

        if (k === "paymentactivityTab") {
            fetchPaymentActivityList(apiFilter)
        }
        else {
            fetchPharmacyDetailsList(apiFilterpharmacy);
            fetchCapturedActivityList(apiFiltercaptured);
            fetchReplenishedActivityList(apiFilterreplenish);
        }
        setkey(k);
        setReset(!reset);
        const min = 1;
        const max = 10000;
        handleFilterReset = min + Math.random() * (max - min);
    };

    const [activeTab, setActiveTab] = useState(1);

    const toggle = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        };
        let initialFiltervalue = {
            currentPage: 1,
            pageSize: 10,
            orderBy: 'modifiedDate',
            order: 'desc',
            filters: [],
        }
        if (tab == 1) {
            fetchPharmacyDetailsList(initialFiltervalue);
        }
        else if (tab == 2) {
            fetchCapturedActivityList(initialFiltervalue);
        }
        else {
            fetchReplenishedActivityList(initialFiltervalue);
        }
        const min = 1;
        const max = 10000;
        handleFilterReset = min + Math.random() * (max - min);
    };

    const [commentDrawer, setCommentDrawer] = useState(false);

    const toggCommentDrawer = (row) => {
        let initialFiltervalue = {
            currentPage: 1,
            pageSize: 10,
            orderBy: 'modifiedDate',
            order: 'desc',
            filters: [],
        };
        setCommentDrawer(!commentDrawer);
        fetchPaymentActivityList(initialFiltervalue);
    };

    const toggCommentDrawerpharmacy = () => {

        let initialFiltervalue = {
            currentPage: 1,
            pageSize: 10,
            orderBy: 'modifiedDate',
            order: 'desc',
            filters: [],
        };
        setCommentDrawer(!commentDrawer);
        fetchPharmacyDetailsList(initialFiltervalue);
    };

    const toggCommentDrawercaptured = () => {

        let initialFiltervalue = {
            currentPage: 1,
            pageSize: 10,
            orderBy: 'modifiedDate',
            order: 'desc',
            filters: [],
        };
        setCommentDrawer(!commentDrawer);
        fetchCapturedActivityList(initialFiltervalue);
    };

    const toggCommentDrawerreplinish = () => {

        let initialFiltervalue = {
            currentPage: 1,
            pageSize: 10,
            orderBy: 'modifiedDate',
            order: 'desc',
            filters: [],
        };
        setCommentDrawer(!commentDrawer);
        fetchReplenishedActivityList(initialFiltervalue);
    };

    const handleExportPaymentActivity = async (row) => {

        let filter = { ...payloaddata, ...apiFilter };
        const { id_token } = JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
        const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/PaymentActivity/export?access_token=${id_token}`;
        onExport(action, filter);
    };

    const handleExportPharmacyActivity = async (row) => {

        let filter = { ...payloaddata, ...apiFilterpharmacy };
        const { id_token } = JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
        const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/PharmacyActivity/export?access_token=${id_token}`;
        onExport(action, filter);
    };
    const handleExportCapturedActivity = async (row) => {

        let filter = { ...payloaddata, ...apiFiltercaptured };
        const { id_token } = JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
        const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/CapturedActivity/export?access_token=${id_token}`;
        onExport(action, filter);
    };
    const handleExportReplenishedActivity = async (row) => {

        let filter = { ...payloaddata, ...apiFilterreplenish };
        const { id_token } = JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
        const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/ReplenishedActivity/export?access_token=${id_token}`;
        onExport(action, filter);
    };

    return (
        <div>
            <Container fluid className=' my-0 bin_info'>
                <Card className=''>
                    <CardBody>
                        <Tabs
                            id="controlled-tab-example"
                            activeKey={key}
                            onSelect={onKeyChange}
                            className="mb-0"
                        >
                            <Tab eventKey="paymentactivityTab" title="Payment Activity">
                                <ErrorBoundary>
                                    <PaymentActivity
                                        toggCommentDrawer={toggCommentDrawer}
                                        loading={loading}
                                        tabledata={paymenttabledata}
                                        apiFilter={apiFilter}
                                        totalSize={totalSize}
                                        onPageChange={handlePaymentActivityPageChange}
                                        refetch={payActrefetch}
                                        onSearchColumnFilters={handleSearchPaymentActivityColumnFilters}
                                        handleExport={handleExportPaymentActivity}
                                        CoveredEntity={CoveredEntity}
                                        opaCode={opaCode}
                                        Cycle={Cycle}
                                        TotalPaymentReceived={TotalPaymentReceived}
                                        PendingAmount={PendingAmount}
                                        handleFilterReset={handleFilterReset}
                                    />
                                </ErrorBoundary>
                            </Tab>
                            <Tab eventKey="pharmacydetailsTab" title="Pharmacy Activity">
                                <ErrorBoundary>
                                    <Row>
                                        <Col md={4}>
                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                                <Input type='radio' checked={activeTab == 1}
                                                    onClick={(e) => {
                                                        toggle(1);
                                                    }}
                                                /><b style={{ color: '#702c62', marginLeft: "5px" }}>Pharmacy Level Fees</b>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                                <Input type='radio' checked={activeTab == 2} onClick={(e) => {
                                                    toggle(2);
                                                }} /> <b style={{ color: '#702c62', marginLeft: "5px" }}>Captured Activity</b>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                                <Input type='radio' checked={activeTab == 3} onClick={(e) => {
                                                    toggle(3);
                                                }} /><b style={{ color: '#702c62', marginLeft: "5px" }}>Replenished Activity</b>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className='align-items-center' style={{ height: "55px" }}>
                                        <Col md='auto' className='pe-3'>
                                            <p className='f-14 mb-0'>
                                                Covered Entity:
                                                <b className='d-inline-block ps-2 font-weight-500'>
                                                    <span>{CoveredEntity}</span>
                                                </b>
                                            </p>
                                        </Col>
                                        <Col md='auto' className='pe-3'>
                                            <p className='f-14 mb-0'>
                                                340B ID:
                                                <b className='d-inline-block ps-2 font-weight-500'>
                                                    <span>{opaCode}</span>
                                                </b>
                                            </p>
                                        </Col>
                                        <Col md='auto' className='pe-3'>
                                            <p className='f-14 mb-0'>
                                                Cycle:
                                                <b className='d-inline-block ps-2 font-weight-500'>
                                                    <span>{Cycle}</span>
                                                </b>
                                            </p>
                                        </Col>
                                    </Row>
                                    <div hidden={activeTab != 1}>
                                        <PharmacyDetails
                                            toggCommentDrawer={toggCommentDrawerpharmacy}
                                            loading={loading}
                                            tabledata={pharmacytabledata}
                                            apiFilter={apiFilterpharmacy}
                                            totalSize={totalSize}
                                            onPageChange={handlePharmacyDetailsPageChange}
                                            refetch={phaActrefetch}
                                            onSearchColumnFilters={handleSearchPharmacyDetailsColumnFilters}
                                            handleExport={handleExportPharmacyActivity}
                                            handleFilterReset={handleFilterReset}
                                        />
                                    </div>
                                    <div hidden={activeTab != 2}>
                                        <CapturedActivity
                                            toggCommentDrawer={toggCommentDrawercaptured}
                                            loading={loading}
                                            tabledata={capturedtabledata}
                                            apiFilter={apiFiltercaptured}
                                            totalSize={totalSize}
                                            onPageChange={handleCapturedPageChange}
                                            refetch={CapActrefetch}
                                            onSearchColumnFilters={handleSearchCapturedActivityColumnFilters}
                                            handleExport={handleExportCapturedActivity}
                                            handleFilterReset={handleFilterReset}
                                        />
                                    </div>
                                    <div hidden={activeTab != 3}>
                                        <ReplenishedActivity
                                            toggCommentDrawer={toggCommentDrawerreplinish}
                                            loading={loading}
                                            tabledata={replenishedtabledata}
                                            apiFilter={apiFilterreplenish}
                                            totalSize={totalSize}
                                            onPageChange={handleReplenishedPageChange}
                                            refetch={RepActrefetch}
                                            onSearchColumnFilters={handleSearchReplenishedActivityColumnFilters}
                                            handleExport={handleExportReplenishedActivity}
                                            handleFilterReset={handleFilterReset}
                                        />
                                    </div>
                                </ErrorBoundary>
                            </Tab>
                        </Tabs>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default PaymentReconciliation;